import { FlightClassesEffects } from '@shared/store/travel/effects/flight-classes.effects';
import { HotelEffects } from '@shared/store/travel/effects/hotel.effects';

export const travelEffects: any[] = [FlightClassesEffects, HotelEffects];

export * from './flight-classes.effects';
export * from './hotel.effects';
